import { useState } from 'react';
import { usePanelActions } from './usePanelActions';

export function usePanelIsLoading() {
  const [isLoading, setIsLoading] = useState(false);

  usePanelActions({
    preRefresh: () => setIsLoading(true),
    refresh: () => setIsLoading(false),
  });

  return isLoading;
}
